export const PRODUCT_PLANS = {
  menuEmbed: 'menu_embed',
  starter: 'starter',
  sysco: 'sysco_premier',
} as const;

export type ProductPlan = (typeof PRODUCT_PLANS)[keyof typeof PRODUCT_PLANS];

const PRODUCT_PLAN_ROUTES: Record<ProductPlan, string> = {
  [PRODUCT_PLANS.menuEmbed]: '/sign-up/menu-embed',
  [PRODUCT_PLANS.starter]: '/sign-up/starter',
  [PRODUCT_PLANS.sysco]: '/sign-up/sysco',
};

const PRODUCT_PLAN_SLUGS: Record<string, ProductPlan> = {
  'menu-embed': PRODUCT_PLANS.menuEmbed,
  starter: PRODUCT_PLANS.starter,
  sysco: PRODUCT_PLANS.sysco,
};

const ALTERNATE_PRODUCT_PLANS: Partial<Record<ProductPlan, ProductPlan>> = {
  [PRODUCT_PLANS.menuEmbed]: PRODUCT_PLANS.starter,
  [PRODUCT_PLANS.starter]: PRODUCT_PLANS.menuEmbed,
};

const PRODUCT_PLAN_BILLING_SLUG_OVERRIDES: Partial<Record<ProductPlan, string>> = {
  [PRODUCT_PLANS.sysco]: 'sysco_premier',
};

export const getProductPlanFromSlug = (slug?: string): ProductPlan | undefined => (
  slug ? PRODUCT_PLAN_SLUGS[slug] : undefined
);

export const getProductPlanRoute = (productPlan: ProductPlan): string => PRODUCT_PLAN_ROUTES[productPlan];

export const getProductPlanBillingSlug = (productPlan: ProductPlan): string => (
  PRODUCT_PLAN_BILLING_SLUG_OVERRIDES[productPlan] ?? productPlan
);

export const getAlternateProductPlan = (productPlan: ProductPlan): ProductPlan | undefined => ALTERNATE_PRODUCT_PLANS[productPlan];
